import React from 'react';
import PropTypes from 'prop-types';

const BadlyWrittenReadingThermometer = ({score}) => {
  const HIGH_SCORE = 300;
  const WIDTH = 95;
  const HEIGHT = 370;
  const strokeWidth = 12;

  const otherPageElementsHeight = 190;
  const containerPadding = 12;
  const outerHeight = window.innerHeight - otherPageElementsHeight - containerPadding * 2;
  const maxDisplayHeight = 1200;

  const scoreFontSize = 26;
  const bulbInner = WIDTH - strokeWidth;
  const scoreTextOffset = HEIGHT - bulbInner / 2;

  const scoreDomain = HEIGHT - strokeWidth - bulbInner;
  const scoreIncrement = scoreDomain / HIGH_SCORE;
  const maskOffset = HEIGHT - score * scoreIncrement - bulbInner;

  const ticks = [0, 25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 275];
  const tickSpacing = scoreDomain / ticks.length;
  const tickFontSize = 10;
  const legendOffset = [39, tickSpacing + 3];

  const tickGroup = (tick, index) => (
    <g className="readicator__tick" key={index} transform={`translate(20, ${index * tickSpacing})`}>
      <rect className="readicator__tick" width="15" height="2" x={3} y={5} />
      <circle r={3} cx={4} cy={5.5} />
      <text x={20} y={6} fontSize={tickFontSize}>
        {tick}
      </text>
    </g>
  );

  return (
    <div
      // the tooltip is implemented with hint-css: styles/vendor/_hint-css.scss
      className="Readicator u_link hint--left hint--bounce cursor-pointer"
      style={{padding: containerPadding, paddingRight: 32}}
      aria-label="Total nights read"
    >
      <svg
        viewBox="0 0 95 370"
        preserveAspectRatio="xMinYMin meet"
        height={outerHeight < maxDisplayHeight ? outerHeight : maxDisplayHeight}
        // width={ 150 } // max-width
      >
        <def>
          <path
            id="readicatorOuterShape"
            d="M80 324c0 19.3-15.7 35-35 35s-35-15.7-35-35c0-12.8 6.8-24 17-30V27c0-10 8-18 18-18s18 8 18 18v267c10.2 6 17 17.3 17 30z"
          />
          <rect
            id="readicatorMaskRect"
            x={strokeWidth - 1}
            y={strokeWidth - 1}
            width={WIDTH - strokeWidth * 2 - 2}
            height={HEIGHT - strokeWidth * 2 - 2}
          />
        </def>

        <clipPath id="readicator__mask">
          <rect x={0} y={maskOffset} width={WIDTH} height={HEIGHT} />
        </clipPath>
        <path
          className="readicator__bg"
          d="M80 324c0 19.3-15.7 35-35 35s-35-15.7-35-35c0-12.8 6.8-24 17-30V27c0-10 8-18 18-18s18 8 18 18v267c10.2 6 17 17.3 17 30z"
        />
        <path
          className="readicator__fill"
          clipPath="url(#readicator__mask)"
          d="M80 324c0 19.3-15.7 35-35 35s-35-15.7-35-35c0-12.8 6.8-24 17-30V27c0-10 8-18 18-18s18 8 18 18v267c10.2 6 17 17.3 17 30z"
        />

        <g className="bubbles" transform={`translate(${WIDTH / 2}, ${maskOffset + 60})`}>
          {// create a couple of bubbles on the fly...
          [...Array(4)].map((x, i) => (
            <circle className="bubble" key={i} r={10} cx={Math.random() * 5} cy={40} />
          ))}
        </g>

        <path
          className="readicator__stroke"
          strokeWidth={strokeWidth}
          d="M80 324c0 19.3-15.7 35-35 35s-35-15.7-35-35c0-12.8 6.8-24 17-30V27c0-10 8-18 18-18s18 8 18 18v267c10.2 6 17 17.3 17 30z"
        />

        <g className="readicator__legend" transform={`translate( ${legendOffset} )`}>
          {ticks.reverse().map(tickGroup)}
        </g>

        <text
          className="readicator__score"
          // the half got thrown off by widening for the legend
          x={WIDTH / 2 - 3}
          y={scoreTextOffset - 5}
          width={10}
          fontSize={scoreFontSize}
        >
          {score}
        </text>
      </svg>
    </div>
  );
};

BadlyWrittenReadingThermometer.propTypes = {
  score: PropTypes.number,
};

BadlyWrittenReadingThermometer.defaultProps = {
  score: 0,
};

export default BadlyWrittenReadingThermometer;
